"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// Note -
// Global Typography

// Form Input font-size

var inputFontSize = exports.inputFontSize = "16px";
var placeFont = exports.placeFont = "13px";

var fontLight = exports.fontLight = "300";
var fontRegular = exports.fontRegular = "400";
var fontMedium = exports.fontMedium = "500";
var fontSemiBold = exports.fontSemiBold = "600";
var fontBold = exports.fontBold = "700";

//  Base font size

var baseFont = exports.baseFont = "16px";

// Heading

var H1 = exports.H1 = "36px";
var H2 = exports.H2 = "30px";
var H3 = exports.H3 = "26px";
var H4 = exports.H4 = "20px";
var H5 = exports.H5 = "18px";
var H6 = exports.H6 = "14px";